// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2yS1S","productName":"Table_productName__2-E71"};